import { useMemo } from "react";
import { LoyaltyMoreRewards } from "../../components/organisms/LoyaltyMoreRewards";
import { useGetProgressLoyalty } from "../../queries/useGetProgressLoyalty";
import { useGetUserProgressLoyalty } from "../../queries/useGetUserProgressLoyalty";

export const LoyaltyMoreRewardsContainer = () => {
  const { data } = useGetUserProgressLoyalty();
  const { data: progressData } = useGetProgressLoyalty();
  const experience = progressData?.data?.data?.experience || 0;

  const rewardsNextRank = useMemo(() => {
    if (!data?.ranks?.length) {
      return null;
    }

    if (experience < data.ranks[0].levels[0].requirement) {
      return data.ranks[0].rewards;
    }

    const currentRank = data.ranks.find((rank, index) => {
      const nextRank = data.ranks[index + 1];
      return (
        nextRank &&
        experience >= rank.levels[0].requirement &&
        experience < nextRank.levels[0].requirement
      );
    });

    if (currentRank) {
      const currentRankIndex = data.ranks.indexOf(currentRank);
      return data.ranks[currentRankIndex + 1].rewards;
    }

    return null;
  }, [data?.ranks, experience]);

  return <LoyaltyMoreRewards rewardsNextRank={rewardsNextRank} />;
};
